import { lazy, Suspense, type ReactElement } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/router/ProtectedRoute';
import { RoleRoute } from '@/router/RoleRoute';
import { RouteFallback } from '@/components/shared/RouteFallback';

// BUG-001 (BUGS.md) — route-based code splitting: har bir sahifa alohida chunk.
const DashboardPage = lazy(() => import('./pages/DashboardPage').then((m) => ({ default: m.DashboardPage })));
const BakeriesPage = lazy(() => import('./pages/BakeriesPage').then((m) => ({ default: m.BakeriesPage })));
const BakeryDetailPage = lazy(() => import('./pages/BakeryDetailPage').then((m) => ({ default: m.BakeryDetailPage })));
const StoreModerationPage = lazy(() =>
  import('./pages/StoreModerationPage').then((m) => ({ default: m.StoreModerationPage })),
);
const StoresPage = lazy(() => import('./pages/StoresPage').then((m) => ({ default: m.StoresPage })));
const UsersPage = lazy(() => import('./pages/UsersPage').then((m) => ({ default: m.UsersPage })));
const ProductsPage = lazy(() => import('./pages/ProductsPage').then((m) => ({ default: m.ProductsPage })));
const ReportsPage = lazy(() => import('./pages/ReportsPage').then((m) => ({ default: m.ReportsPage })));
const ReportDetailPage = lazy(() => import('./pages/ReportDetailPage').then((m) => ({ default: m.ReportDetailPage })));
const SettingsPage = lazy(() => import('./pages/SettingsPage').then((m) => ({ default: m.SettingsPage })));
const ProfilePage = lazy(() => import('./pages/ProfilePage').then((m) => ({ default: m.ProfilePage })));
const QuickActionsPage = lazy(() => import('./pages/QuickActionsPage').then((m) => ({ default: m.QuickActionsPage })));
const NotificationsPage = lazy(() =>
  import('./pages/NotificationsPage').then((m) => ({ default: m.NotificationsPage })),
);

function admin(element: ReactElement): ReactElement {
  return (
    <ProtectedRoute>
      <RoleRoute roles={['ADMIN']}>
        <Suspense fallback={<RouteFallback />}>{element}</Suspense>
      </RoleRoute>
    </ProtectedRoute>
  );
}

/**
 * F4 — Admin ekranlari (AD-02…AD-08).
 * CLAUDE.md §6 — registry.ts tomonidan avtomatik yig'iladi.
 * Yo'llar `lib/navConfig.ts` dagi NAV_CONFIG.ADMIN bilan mos.
 */
export const routes: RouteObject[] = [
  { path: '/admin', element: admin(<DashboardPage />) },
  { path: '/admin/dashboard', element: admin(<DashboardPage />) },
  { path: '/admin/bakeries', element: admin(<BakeriesPage />) },
  { path: '/admin/bakeries/:id', element: admin(<BakeryDetailPage />) },
  { path: '/admin/stores', element: admin(<StoresPage />) },
  { path: '/admin/stores/pending', element: admin(<StoreModerationPage />) },
  { path: '/admin/users', element: admin(<UsersPage />) },
  { path: '/admin/products', element: admin(<ProductsPage />) },
  { path: '/admin/reports', element: admin(<ReportsPage />) },
  { path: '/admin/reports/:reportId', element: admin(<ReportDetailPage />) },
  { path: '/admin/settings', element: admin(<SettingsPage />) },
  { path: '/admin/profile', element: admin(<ProfilePage />) },
  { path: '/admin/quick', element: admin(<QuickActionsPage />) },
  { path: '/admin/notifications', element: admin(<NotificationsPage />) },
];
